export class ErrorHandler {
  private static _instance: ErrorHandler;

  static get instance() {
    ErrorHandler._instance = ErrorHandler._instance ?? new ErrorHandler();
    return ErrorHandler._instance;
  }
  private registry: Map<number, (navigation?: () => void) => void>;

  private constructor() {
    this.registry = new Map();
  }

  public static addRegistry(
    code: number,
    handler: (nav?: () => void) => void,
  ): void {
    ErrorHandler.instance.registry.set(code, handler);
  }
  public static removeRegistry(code: number): void {
    if (ErrorHandler.instance.registry.has(code)) {
      ErrorHandler.instance.registry.delete(code);
      return;
    }
  }
  public static handle(code: number, additionalProcess?: () => void) {
    if (ErrorHandler.instance.registry.has(code)) {
      return ErrorHandler.instance.registry.get(code)?.(additionalProcess);
    }
    return ErrorHandler.defaultHandler(code);
  }
  public static defaultHandler(code: number, additionalProcess?: () => void) {
    console.log(`>> Error code [${code}] not handle`);
    additionalProcess?.();
  }
}
